import { useEffect, useState } from 'react';
import axios from 'axios';
import { useCookies } from 'react-cookie'
import { api } from '../../common/api' 
import { ACCESS_TOKEN } from '../../common/util' 

function useCreateProgram() { 
    const baseUrl = api.base_url;
    const [cookies, setCookie, removeCookie] = useCookies([ACCESS_TOKEN]);
    
    const createProgram = async (formData:any) => {
        
        try {
            const response = await axios.post(`${baseUrl}/program/post-program`, formData, {
                headers: {
                  'Content-Type': "multipart/form-data",
                  'Authorization': `Bearer ${cookies[ACCESS_TOKEN]}`,
                },
            });
            
            return response.status;
        } catch (error) {
            console.error(error);
        }
    };

    return { createProgram };
}

export default useCreateProgram;
